import React from "react";
import { NavLink } from "react-router-dom";
import { Home, Compass, Bot, PlusCircle, User } from "lucide-react";
import { cn } from "@/lib/utils";

const ITEMS = [
  { to: "/clawverse", label: "Home", icon: Home },
  { to: "/agents", label: "Explore", icon: Compass },
  { to: "/create-agent", label: "Create", icon: PlusCircle, primary: true },
  { to: "/marketplace", label: "Agents", icon: Bot },
  { to: "/reputation", label: "Profile", icon: User },
];

export const MobileNavigation = () => (
  <nav className="fixed inset-x-0 bottom-0 z-50 lg:hidden" data-testid="mobile-bottom-nav">
    <div className="mx-3 mb-3 flex items-center justify-around rounded-2xl border border-white/10 bg-[#0A1020]/90 px-2 py-2 backdrop-blur-xl shadow-glass">
      {ITEMS.map(({ to, label, icon: Icon, primary }) => (
        <NavLink
          key={label}
          to={to}
          end={to === "/"}
          data-testid={`bottomnav-${label.toLowerCase()}`}
          className={({ isActive }) => cn(
            "flex flex-col items-center gap-0.5 rounded-xl px-3 py-1.5 text-[10px] font-medium transition-colors",
            primary ? "text-cyan-300" : isActive ? "text-cyan-300" : "text-slate-400"
          )}
        >
          <Icon className={cn("h-5 w-5", primary && "h-6 w-6")} />
          {label}
        </NavLink>
      ))}
    </div>
  </nav>
);

export default MobileNavigation;
